module.exports = __webpack_public_path__ + "static/media/telegram.41140f93.svg";